import { StyleSheet } from 'react-native';
import { appTheme } from '@/config/colors';

export default StyleSheet.create({
  container: {
    flex: 1,
    padding: 5,
  },
  settings: {
    flex: 2,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignContent: 'flex-start',
    marginTop: 5,
    marginHorizontal: 5,
  },
  card: {
    width: '49.7%',
    minHeight: 250,
    backgroundColor: '#ffff',
    marginVertical: 5,
    padding: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },
  btnsContainer: {
    paddingVertical: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  btn: {
    flex: 1,
    marginHorizontal: 5,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#aaaa',
    paddingVertical: 10,
    borderRadius: 2,
  },
  btnText: {
    fontSize: 16,
    color: '#3a3a3a',
    fontWeight: '700',
  },
  blueText: {
    color: '#eeee',
  },
  bgBlue: {
    backgroundColor: appTheme.primary,
  },
  warningContainer: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  warningText: {
    maxWidth: '95%',
    fontSize: 20,
    fontWeight: 600,
    marginLeft: 10,
  },
});
